import React, { useEffect, useRef, useState } from "react";
import Modal from "react-modal";
import emailjs from "emailjs-com";
import { toast } from "react-toastify";

const emailIds = {
    service: "ashrafraneem@gmail.com",
    template: "template_ewrlaqr",
    public: "GaFNuMtuqM2kjZlbe",
};

const customStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        borderRadius: "20px",
        transform: "translate(-50%, -50%)",
        background: "#111a20",
        width: "600px",
    },
};

const ContactModal = (props) => {
    const { isOpen, setIsOpen } = props;
    const [loader, setLoader] = useState(false);
    const [isEmpty, setIsEmpty] = useState(true);

    const form = useRef();

    const onSubmit = (e) => {
        e.preventDefault();

        setLoader(true);
        emailjs.sendForm(emailIds.service, emailIds.template, form.current, emailIds.public).then(
            (result) => {
                toast.success("Email sent successfully, you will be contacted shortly");
                setLoader(false);
                setIsOpen(false);
            },
            (error) => {
                toast.error("Email could not be sent");
                setLoader(false);
                setIsOpen(false);
            },
        );
    };

    useEffect(() => {
        setIsEmpty(true);
    }, []);

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={() => setIsOpen(false)}
            style={customStyles}
            contentLabel="Example Modal"
            closeTimeoutMS={200}
            bodyOpenClassName="modal-body"
        >
            <div className="flex flex-col p-4">
                <h2 className="text-3xl">Drop Something In</h2>
                <form className="flex flex-col mt-4" ref={form} onSubmit={onSubmit}>
                    <div className="flex flex-col my-2">
                        <label className="text-light mb-2">Name</label>
                        <input
                            type="text"
                            className="bg-light text-primary px-2 py-1 rounded focus:outline-none"
                            name="name"
                            onChange={() => setIsEmpty(false)}
                        />
                    </div>
                    <div className="flex flex-col my-2">
                        <label className="text-light mb-2">Email</label>
                        <input
                            type="text"
                            className="bg-light text-primary px-2 py-1 rounded focus:outline-none"
                            name="email"
                            onChange={() => setIsEmpty(false)}
                        />
                    </div>
                    <div className="flex flex-col my-2">
                        <label className="text-light mb-2">Message</label>
                        <textarea
                            className="bg-light h-[200px] text-primary px-2 py-1 rounded focus:outline-none"
                            name="message"
                        />
                    </div>
                    <div className="flex flex-row justify-between mt-6">
                        <button
                            type="submit"
                            onSubmit={onSubmit}
                            disabled={isEmpty}
                            className={`${
                                isEmpty ? "bg-[#82f9b433]" : "bg-secondary"
                            } py-3 px-6 rounded-xl cursor-pointer text-primary`}
                        >
                            {loader ? "Sending..." : "Submit"}
                        </button>
                        <button
                            onClick={(e) => {
                                e.preventDefault();
                                setIsOpen(false);
                            }}
                        >
                            Close
                        </button>
                    </div>
                </form>
            </div>
        </Modal>
    );
};

export default ContactModal;
